import React from 'react';

import { Divider, Grid } from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const HeaderContainer = ({ children, sxDivider = {} }) => (
    <React.Fragment>
        <Grid container sx={{ my: 1 }}>
            <Grid size={{ xs: 'grow' }}>{children}</Grid>
        </Grid>

        <Divider sx={{ mb: 2, ...sxDivider }} />
    </React.Fragment>
);

HeaderContainer.propTypes = {
    children: PropTypes.node,
    sxDivider: PropTypes.object,
};

export default HeaderContainer;
